import React from "react";
import { useNavigate } from "react-router-dom";

import SearchesList from "../components/scouting/SearchesList";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const SearchesListRoute = () => {
  const navigate = useNavigate();
  const { scoutData, scoutSearches, refreshScoutSearches } = useAuth();
  const { openNotifications } = useNotifications();

  return (
    <SearchesList
      scoutId={scoutData?.id}
      searches={scoutSearches}
      displayName={scoutData?.full_name || "Scout"}
      onNotificationsClick={openNotifications}
      onOpenSearch={(searchId) => navigate(`/scout/searches/${searchId}`)}
      onCreated={refreshScoutSearches}
    />
  );
};

export default SearchesListRoute;
